import type { AppEvent } from 'src/common/events/appEvents';
import type { SteeringActionPayload, SteeringActionType, SteeringResponse } from '../types';

export type Action = {
  action: SteeringActionType;
  getHref(attributes: SteeringResponse['attributes'], clientId: string | null): string;
  getFollowUp(
    attributes: SteeringResponse['attributes'],
  ): { title: string; message: string } | null;
  completionEvents: AppEvent[];
};

type AttributesFor<T extends SteeringActionType> = Extract<
  SteeringActionPayload,
  { action: T }
>['attributes'];

export function defineAction<T extends SteeringActionType>(config: {
  action: T;
  getHref(attributes: AttributesFor<T>, clientId: string | null): string;
  getFollowUp(attributes: AttributesFor<T>): { title: string; message: string } | null;
  completionEvents: AppEvent[];
}): Action {
  return config;
}
